import type { ReactNode } from 'react';
import { ResourceRewards, type ResourceReward } from '@entities/game-resource';
import { IconCheck } from '@tabler/icons-react';
import classes from './round-result-overlay.module.css';

type Props = {
  correct: boolean;
  title: string;
  reward?: { exp: number; coins: number } & ResourceReward;
  children?: ReactNode;
  ariaLabel?: string;
};

export const RoundResultOverlay = ({ correct, title, reward, children, ariaLabel = 'Результат ответа' }: Props) => (
  <div className={classes.root} data-correct={correct || undefined} role="status" aria-label={ariaLabel}>
    <div className={classes.heading}>
      {correct && <IconCheck className={classes.check} size={32} stroke={3} aria-hidden="true" />}
      <strong className={classes.title}>{title}</strong>
    </div>
    {correct && reward && (
      <div className={classes.reward} aria-label="Награда за ответ">
        <strong>+{reward.exp} XP</strong>
        {reward.coins > 0 && (
          <strong>
            <img src="/uznabuck.webp" alt="Узнабаки" /> +{reward.coins}
          </strong>
        )}
        <ResourceRewards rewards={reward} />
      </div>
    )}
    {children}
  </div>
);
